/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerGeneratePdfMutationResponse, ApplicationsControllerGeneratePdfPathParams, ApplicationsControllerGeneratePdf400, ApplicationsControllerGeneratePdf401, ApplicationsControllerGeneratePdf403, ApplicationsControllerGeneratePdf404 } from "../../models/checklistsController/ApplicationsControllerGeneratePdf";

function getApplicationsControllerGeneratePdfUrl(id: ApplicationsControllerGeneratePdfPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/checklist-applications/${id}/pdf` as const }  
  return res
}

/**
 * @description Renders the checklist application (sections, questions, summaries, and source citations) as a PDF and returns the bytes.
 * @summary Generate a playbook PDF
 * {@link /api/v1/checklist-applications/:id/pdf}
 */
export async function applicationsControllerGeneratePdf(id: ApplicationsControllerGeneratePdfPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationsControllerGeneratePdfMutationResponse, ResponseErrorConfig<ApplicationsControllerGeneratePdf400 | ApplicationsControllerGeneratePdf401 | ApplicationsControllerGeneratePdf403 | ApplicationsControllerGeneratePdf404>, unknown>({ method : "POST", url : getApplicationsControllerGeneratePdfUrl(id).url.toString(), ... requestConfig })  
  return res.data
}